var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHorizontalMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1667 12C21.1667 11.0795 20.4205 10.3333 19.5 10.3333C18.5795 10.3333 17.8333 11.0795 17.8333 12C17.8333 12.9205 18.5795 13.6667 19.5 13.6667C20.4205 13.6667 21.1667 12.9205 21.1667 12ZM19.5 9.50002C20.8807 9.50002 22 10.6193 22 12C22 13.3807 20.8807 14.5 19.5 14.5C18.1193 14.5 17 13.3807 17 12C17 10.6193 18.1193 9.50002 19.5 9.50002Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6667 12C13.6667 11.0795 12.9205 10.3333 12 10.3333C11.0795 10.3333 10.3333 11.0795 10.3333 12C10.3333 12.9205 11.0795 13.6667 12 13.6667C12.9205 13.6667 13.6667 12.9205 13.6667 12ZM12 9.50002C13.3807 9.50002 14.5 10.6193 14.5 12C14.5 13.3807 13.3807 14.5 12 14.5C10.6193 14.5 9.5 13.3807 9.5 12C9.5 10.6193 10.6193 9.50002 12 9.50002Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16667 12C6.16667 11.0795 5.42048 10.3333 4.5 10.3333C3.57952 10.3333 2.83333 11.0795 2.83333 12C2.83333 12.9205 3.57952 13.6667 4.5 13.6667C5.42048 13.6667 6.16667 12.9205 6.16667 12ZM4.5 9.50002C5.88071 9.50002 7 10.6193 7 12C7 13.3807 5.88071 14.5 4.5 14.5C3.11929 14.5 2 13.3807 2 12C2 10.6193 3.11929 9.50002 4.5 9.50002Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalMenu);
export default __webpack_public_path__ + "static/media/horizontal_menu.3c8d2cffbb4ed9d74b65f2092750f49e.svg";
export { ForwardRef as ReactComponent };